import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "components/PurpleTheme/Card";
import ReactApexChart from "react-apexcharts";
import {Input, FormFeedback} from "reactstrap";
import {
  getBluejayTeam,
  getMTTAMTTRMetrics as onGetMTTMetrics,
  getServices,
  getMTTAMTTRMetricsForTeams as onGetMTTMetricsForTeams} from "store/actions"
import Select from "react-select";

const MttrMtta = () => {
  const dispatch = useDispatch();
  const[filters, setFilters] = useState(true);
  const headers = ['User', 'Alerts acknowledged', 'Alerts resolved', 'MTTA', 'MTTR'];

  const [teamOptions, setTeamOptions] = useState([])
  const [selectedTeamOption, setSelectedTeamOption] = useState(null)

  const [serviceOptions, setServiceOptions] = useState([])
  const [selectedServiceOption, setSelectedServiceOption] = useState(null)

  const today = new Date()
  const lastWeek = new Date()
  lastWeek.setDate(today.getDate() - 7)
  const [startDate, setStartDate] = useState(lastWeek.toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState(today.toISOString().split('T')[0])
  const [isValid, setIsValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  const [mttaData, setMTTAData] = useState([])
  const [mttrData, setMTTRData] = useState([])

  const { mtta_mttr_data } = useSelector(state => ({
    mtta_mttr_data: state.AlcomScoreDashboard.mtta_mttr_data || {},
  }));

  const { services } = useSelector(state => ({
    services: state.Service.services
  }));

  const { teams } = useSelector(state => ({
    teams: state.Organization.bluejay_teams || []
  }))

  useEffect(() => {
    dispatch(getBluejayTeam())
    dispatch(getServices())
  }, [dispatch]);

  useEffect(() => {
    const options = services.map((service) => {
      return {
        label: service.name,
        value: service.id
      };
    });
    setServiceOptions(options);
  }, [services]);


  useEffect(() => {
    const options = teams.map((team) => {
      return{
        label: team.name,
        value: team.id
      }
    })
    options.unshift({
      label: "All Teams",
      value: "all_teams"
    })
    setTeamOptions(options);
    if (!selectedTeamOption && options.length > 0) {
      setSelectedTeamOption(options[0].value);
    }
  }, [teams])
  useEffect(() => {
    if (startDate !== null && endDate !== null && isValid){
      const payload = {
        "start_date": startDate,
        "end_date": endDate
      }
      if (selectedServiceOption !== null &&  selectedTeamOption === null) {
        payload["application_service_id"] = selectedServiceOption
        dispatch(onGetMTTMetrics(payload))
      } else if(selectedServiceOption === null &&  selectedTeamOption !== null){
        if(selectedTeamOption !== "all_teams")
          payload["bluejay_team_id"] = selectedTeamOption
        dispatch(onGetMTTMetricsForTeams(payload))
      }
    }
  }, [selectedTeamOption, selectedServiceOption, startDate, endDate]);

  useEffect(() => {
    if(mtta_mttr_data !== null && mtta_mttr_data?.mttr_data && mtta_mttr_data?.mtta_data){
      setMTTAData(Object.keys(mtta_mttr_data.mtta_data).map(date => ({
        x: date,
        y: Math.round(mtta_mttr_data.mtta_data[date] /60)
      })));
      setMTTRData(Object.keys(mtta_mttr_data.mttr_data).map(date => ({
        x: date,
        y: Math.round(mtta_mttr_data.mttr_data[date] /60)
      })));
    }
  }, [mtta_mttr_data]);

  const validateDates = (start, end) => {
    const startD = new Date(start);
    const endD = new Date(end);

    if (startD >= endD) {
      setErrorMessage("Start date can't be after or on the end date");
      setIsValid(false);
    } else if (Math.floor((endD - startD) / (1000 * 60 * 60 * 24)) > 31) {
      setErrorMessage("Date difference can't be more than 31 days");
      setIsValid(false);
    } else {
      setErrorMessage('');
      setIsValid(true);
    }
  };

  const handleStartDateChange = (e) => {
    const value = e.target.value;
    setStartDate(value);
    validateDates(value, endDate);
  };

  const handleEndDateChange = (e) => {
    const value = e.target.value;
    setEndDate(value);
    validateDates(startDate, value);
  };

  const customStyles = {
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      position:"relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position:"relative",
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#382b42',
      position: "absolute", // Background color of the dropdown men
    }),
    singleValue: (provided) => ({
      ...provided,
      position:"relative",
      color: '#ffffff', // Color of the selected value
    }),
  };

  const options = {
    chart: {
      height: 350,
      type: 'line',
      dropShadow: {
        enabled: false,
        color: '#000',
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2
      },
      zoom: {
        type: 'x',
        enabled: false,
      },
      toolbar: {
        enabled: false
      }
    },
    colors: ['#F1734F', '#9E00FF'],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2
    },
    grid: {
      borderColor: '#e7e7e7',
      row: {
        colors: ['transparent'],
        opacity: 0.3
      },
    },
    xaxis: {
      title: {
        text: 'Month'
      },
      tooltip: {
        enabled: false
      }
    },
    yaxis: {
      title: {
        text: 'Minutes'
      },
    },
    legend: {
      position: 'top',
    },
    tooltip: {
      shared: true,
      hideEmptySeries: false,
    }
  };

  return(
    <React.Fragment>
      <div style={{width:"94%"}}>
        <h1>MTTR & MTTA</h1>
        <div>
          <div className="w-100 d-flex justify-content-end mb-2">
            <button onClick={() => setFilters(!filters)} className="btn btn-primary d-flex align-items-center">
            <span>Filters</span>
            <i className="mdi mdi-filter-outline" />
            </button>
          </div>
        </div>
        {filters ?
          <div className="d-flex align-items-center gap-5 justify-content-between mb-4">
            <div className="d-flex flex-column justify-content-start w-50">
              <h5>Filters</h5>
              <div className="d-flex align-items-center gap-3 w-100">
                <div className="w-50">
                  <Select
                    id='team_select'
                    name="custom_select"
                    placeholder="Team"
                    onChange={(option) => {
                      setSelectedServiceOption(null)
                      setSelectedTeamOption(option.value)
                    }}
                    value={teamOptions.find(option => option.value === selectedTeamOption) || null}
                    options={teamOptions}
                    className="select2-selection col-form-label bg-transparent text-white"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        neutral0: '#222736',
                        neutral5: '#485EC4',
                        neutral10: '#485EC4',
                        neutral60: '#ffffff',
                        neutral70: '#ffffff',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                        primary: '#485EC4',
                      },
                    })}
                    styles={customStyles}
                  />
                </div>
                <div className="w-50">
                  <Select
                    id='service_select'
                    name="custom_select"
                    placeholder="Service"
                    onChange={(option) => {
                      setSelectedTeamOption(null)
                      setSelectedServiceOption(option.value)
                    }}
                    value={serviceOptions.find(option => option.value === selectedServiceOption) || null}
                    options={serviceOptions}
                    className="select2-selection col-form-label bg-transparent text-white"
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        neutral0: '#222736',
                        neutral5: '#485EC4',
                        neutral10: '#485EC4',
                        neutral60: '#ffffff',
                        neutral70: '#ffffff',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                        primary: '#485EC4',
                      },
                    })}
                    styles={customStyles}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column justify-content-start w-50">
              <h5>Incidents between</h5>
              <div className="d-flex align-items-center gap-3 w-100">
                <div className="w-50">
                  <Input
                    type="date"
                    id="start_date"
                    placeholder="Start date"
                    name="startdate"
                    onChange={handleStartDateChange}
                    value={startDate}
                    invalid={!isValid}
                  />
                </div>
                <div className="w-50">
                  <Input
                    type="date"
                    id="end_date"
                    placeholder="End date"
                    name="enddate"
                    onChange={handleEndDateChange}
                    value={endDate}
                    invalid={!isValid}
                  />
                </div>
              </div>
              {!isValid && (
                <FormFeedback type="invalid" style={{display: 'block'}}>
                  {errorMessage}
                </FormFeedback>
              )}
            </div>
          </div> : null}
        <div className="d-flex gap-4">
          <div className="w-25 pb-3">
            <Card className='h-100 text-center d-flex flex-column justify-content-center'>
              <h2>Incidents</h2>
              <h1>{isValid ? mtta_mttr_data?.total_incidents : "-"}</h1>
              {isValid &&
                <span className="p-0">
                    <span className={mtta_mttr_data?.total_incidents_diff > 0 ? "text-danger" : "text-success"}>
                      {mtta_mttr_data?.total_incidents_diff > 0
                        ? mtta_mttr_data?.total_incidents_diff + "% greater"
                        : (mtta_mttr_data?.total_incidents_diff * -1) + "% lower"}
                    </span><br/> than previous period
                  </span>
                }
                </Card>
            </div>
            <div className='d-flex w-75 gap-4'>
              <div className="w-100 d-flex flex-column">
                <Card className='text-center d-flex flex-column '>
                  <h4>MTTA</h4>
                  <h3>
                    {isValid ?
                      <>
                        <i className={mtta_mttr_data?.mtta_diff > 0 ? "bx bx-caret-up text-danger" : "bx bx-caret-down text-success"}/>
                        <span><span className={mtta_mttr_data?.mtta_diff > 0 ? "text-danger" : "text-success"}>{(mtta_mttr_data.mtta / 60).toFixed(1)}</span> minutes</span>
                      </>
                      : "-"
                    }
                  </h3>
                  {isValid &&
                    <span className="p-0">
                      <span className={mtta_mttr_data?.mtta_diff > 0 ? "text-danger" : "text-success"}>
                        {mtta_mttr_data?.mtta_diff > 0
                          ? mtta_mttr_data?.mtta_diff + "% greater "
                          : (mtta_mttr_data?.mtta_diff * -1) + "% lower "}
                      </span> than previous period
                    </span>
                  }
                </Card>
                <Card className='text-center d-flex flex-column '>
                  <h4>95<sup>th</sup> %ile TTA</h4>
                  {isValid?
                    <>
                      <h3>
                        <i className={mtta_mttr_data?.uqtta_diff > 0 ? "bx bx-caret-up text-danger" : "bx bx-caret-down text-success"}/>
                        <span><span className={mtta_mttr_data?.uqtta_diff > 0 ? "text-danger" : "text-success"}>{(mtta_mttr_data.uqtta / 60).toFixed(1)}</span> minutes</span>
                      </h3>
                    </>
                    : "-"
                  }
                  {isValid &&
                    <span>
                  <span className={mtta_mttr_data?.uqtta_diff > 0 ? "text-danger" : "text-success"}>
                    {mtta_mttr_data?.uqtta_diff > 0
                      ? mtta_mttr_data?.uqtta_diff + "% greater "
                      : (mtta_mttr_data?.uqtta_diff * -1) + "% lower "}
                  </span> than previous period
                </span>
                  }
                </Card>
              </div>
              <div className="w-100 d-flex flex-column">
                <Card className='text-center d-flex flex-column '>
                  <h4>MTTR</h4>
                  {isValid?
                    <>
                      <h3>
                        <i className={mtta_mttr_data?.mttr_diff > 0 ? "bx bx-caret-up text-danger" : "bx bx-caret-down text-success"}/>
                        <span><span className={mtta_mttr_data?.mttr_diff > 0 ? "text-danger" : "text-success"}>{(mtta_mttr_data.mttr / 60).toFixed(1)}</span> minutes</span>
                      </h3>
                    </>
                    : "-"
                  }
                  {isValid &&
                    <span>
                  <span className={mtta_mttr_data?.mttr_diff > 0 ? "text-danger" : "text-success"}>
                    {mtta_mttr_data?.mttr_diff > 0
                      ? mtta_mttr_data?.mttr_diff + "% greater "
                      : (mtta_mttr_data?.mttr_diff * -1) + "% lower "}
                  </span> than previous period
                </span>
                  }
                </Card>
                <Card className='text-center d-flex flex-column '>
                  <h4>95<sup>th</sup> %ile TTR</h4>
                  {isValid?
                    <>
                      <h3>
                        <i className={mtta_mttr_data?.uqttr_diff > 0 ? "bx bx-caret-up text-danger" : "bx bx-caret-down text-success"}/>
                        <span><span className={mtta_mttr_data?.uqttr_diff > 0 ? "text-danger" : "text-success"}>{(mtta_mttr_data.uqttr / 60).toFixed(1)}</span> minutes</span>
                      </h3>
                    </>
                    : "-"
                  }
                  {isValid &&
                    <span>
                  <span className={mtta_mttr_data?.uqttr_diff > 0 ? "text-danger" : "text-success"}>
                    {mtta_mttr_data?.uqttr_diff > 0
                      ? mtta_mttr_data?.uqttr_diff + "% greater "
                      : (mtta_mttr_data?.uqttr_diff * -1) + "% lower "}
                  </span> than previous period
                </span>
                  }
                </Card>
              </div>
            </div>
          </div>
          <div>
            <Card>
              <ReactApexChart
                options={options}
                series={[
                  {
                    name: "MTTA",
                    data: isValid ? mttaData: [],
                  },
                  {
                    name: "MTTR",
                    data: isValid ? mttrData: [],
                  },
                ]}
                type="line"
                height="300"
                className="apex-charts"
              />
            </Card>
            {/*<table className="table-purple-org w-100 ms-2">  TODO: uncomment for teams functionality */}
            {/*  <Row className="header w-100 py-3 px-0">*/}
            {/*    {headers.map((item) => (*/}
            {/*      <Col className="text-center" lg={2} key={item}>{item}</Col>*/}
            {/*    ))}*/}
            {/*  </Row>*/}
            {/*  <Row>*/}
            {/*    {tableData?.map((item, index) => {*/}
            {/*      <Col key={index}>{item}</Col>*/}
            {/*    })}*/}
            {/*  </Row>*/}
            {/*</table>*/}
          </div>
      </div>
    </React.Fragment>
  )
}

export default MttrMtta;
